import React, { Component } from 'react'
import { gql, graphql } from 'react-apollo'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import t from 'prop-types'

import Color from 'helpers/Color'
import {
  Statistic,
  Segment,
  Button,
  Loading,
  Breadcrumbs,
  Grid,
  Notifications,
} from 'components/UI'

class BuildingStats extends Component {
  render () {
    const {
      buildingId,
      selectedResource,
      data,
    } = this.props

    const {
      error,
      loading,
      building,
    } = data

    if (error) return <Notifications.Error message={error.message} />

    const temperature = loading ? null : Math.round(building.temp)
    const buildingPath = `/buildings/${buildingId}`

    const breadcrumbs = [
      { name: loading ? '...' : building.name, to: buildingPath },
    ]
    return (
      <div>
        <Grid.Row>
          <Breadcrumbs items={breadcrumbs} />
        </Grid.Row>
        <Grid.Row columns={4}>
          <Grid.Col>
            { loading ? <Loading /> : (
              <Statistic
                value={temperature ? `${temperature}°` : 'N/A'}
                description='Average Building Temp. (F)'
                color={Color.fromTemperature(temperature)}
              />
            )}
          </Grid.Col>
          <Grid.Col>
            { loading ? <Loading /> : (
              <Statistic
                value={`${building.reporting || 0} of ${building.total || 0}`}
                description='Reporting data'
                color={building.reporting ? Color.red : Color.gray}
              />
            )}
          </Grid.Col>
          <Grid.Col>
            { loading ? <Loading /> : (
              <Statistic
                link={`/alerts/${buildingId}`}
                value={building.alertCount}
                description='Alerts'
                color={building.alertCount === 0 ? Color.gray : Color.red}
              />
            )}
          </Grid.Col>
          <Grid.Col textAlign='center'>
            <Segment centered>
              <div>
                View all {selectedResource} in this building
                <Link to={`${buildingPath}/${selectedResource}`}>
                  <Button big>
                    View {_.capitalize(selectedResource)}
                  </Button>
                </Link>
              </div>
            </Segment>
          </Grid.Col>
        </Grid.Row>
      </div>
    )
  }
}

BuildingStats.propTypes = {
  buildingId: t.string.isRequired,
  selectedResource: t.string.isRequired,
}

const BuildingStatsQuery = gql`
  query BuildingStatsQuery($id: Int!) {
    building(id: $id) {
      name
      temp
      reporting
      total
      alertCount
    }
  }
`
export default graphql(BuildingStatsQuery, {
  options: ({ buildingId }) => ({
    variables: {
      id: buildingId,
    },
    notifyOnNetworkStatusChange: true,
  }),
})(BuildingStats)



// WEBPACK FOOTER //
// ./src/components/Building/BuildingStats.jsx